import React from "react";
import { useQuestions } from "./hooks/useQuestions";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import QuestionsForm from "./components/questionsForm";
import PrincipleQuestionsGrid from "./components/principleQuestionsGrid";

function Questions() {
  const {
    isLargeScreen,
    open,
    editMode,
    handleOpen,
    handleClose,
    setOpen,
    showLocation,

    page,
    setPage,
    limit,
    setLimit,
    search,
    setSearch,
    sort,
    setSort,
    searchInput,
    setSearchInput,

    location,
    setLocation,
  } = useQuestions();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="Welcome to ALT Coach - T&L Foci"
            subtitle="Set the foci for your organisation"
          />
          {showLocation && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpen}
              sx={{
                borderRadius: "5px",
                fontSize: "12px",
                padding: "5px 10px",
              }}
            >
              <QuestionAnswerIcon sx={{ mr: "0.5rem" }} />
              Add new T&L Focus
            </Button>
          )}
        </FlexBetween>

        <PrincipleQuestionsGrid
          editMode={editMode}
          handleOpen={handleOpen}
          handleClose={handleClose}
          setOpen={setOpen}
          showOrg={showLocation}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          search={search}
          setSearch={setSearch}
          sort={sort}
          setSort={setSort}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          location={location}
          setLocation={setLocation}
        />
      </WidgetWrapper>

      {/* Dialog for Adding/Editing Questions */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Add a New T&L Focus</DialogTitle>
        <DialogContent>
          <QuestionsForm
            editMode={editMode}
            setOpen={setOpen}
            handleClose={handleClose}
            page={page}
            limit={limit}
            search={search}
            sort={sort}
            searchInput={searchInput}
            location={location}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Questions;
